import { useState } from "react";
import { Phone, X } from "lucide-react";
import { trackPhoneClick } from "../lib/analytics";

export default function MobileCallBar() {
    const [dismissed, setDismissed] = useState(false);
    if (dismissed) return null;

    return (
        <div
            data-testid="mobile-call-bar"
            className="fixed inset-x-0 bottom-0 z-40 flex items-center gap-2 border-t border-white/10 bg-navy/95 p-3 backdrop-blur-md md:hidden"
        >
            <a
                href="tel:+18333439367"
                data-testid="mobile-call-bar-cta"
                onClick={() => trackPhoneClick("mobile_sticky_bar")}
                className="flex flex-1 items-center justify-center gap-2 rounded-full bg-gold py-3 text-sm font-bold tracking-wide text-navy"
            >
                <Phone size={16} aria-hidden="true" />
                Call Now — +1 833-343-9367
            </a>
            <button
                type="button"
                data-testid="mobile-call-bar-dismiss"
                aria-label="Dismiss call bar"
                onClick={() => setDismissed(true)}
                className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-white/20 text-white/80"
            >
                <X size={16} />
            </button>
        </div>
    );
}
